import script from "./CallBucketPromptBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CallBucketPromptBanner.vue?vue&type=script&setup=true&lang=js"

import "./CallBucketPromptBanner.vue?vue&type=style&index=0&id=251eb44c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251eb44c"]])

export default __exports__